var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3701_3679",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3701_3679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6008 11.9998L8.70078 8.0998C8.51745 7.91647 8.42578 7.68314 8.42578 7.3998C8.42578 7.11647 8.51745 6.88314 8.70078 6.6998C8.88411 6.51647 9.11745 6.4248 9.40078 6.4248C9.68411 6.4248 9.91745 6.51647 10.1008 6.6998L14.7008 11.2998C14.8008 11.3998 14.8716 11.5081 14.9133 11.6248C14.9549 11.7415 14.9758 11.8665 14.9758 11.9998C14.9758 12.1331 14.9549 12.2581 14.9133 12.3748C14.8716 12.4915 14.8008 12.5998 14.7008 12.6998L10.1008 17.2998C9.91745 17.4831 9.68411 17.5748 9.40078 17.5748C9.11745 17.5748 8.88411 17.4831 8.70078 17.2998C8.51745 17.1165 8.42578 16.8831 8.42578 16.5998C8.42578 16.3165 8.51745 16.0831 8.70078 15.8998L12.6008 11.9998Z",
    fill: "#1B1E23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.138ba4e365bf353ab04f5fca719716de.svg";
export { ForwardRef as ReactComponent };